import React, { Component } from "react";
import { Row, Col, Button, Modal, Spinner } from "react-bootstrap";
import "./style.css";
import { Bar, Line } from "react-chartjs-2";
import moment from "moment";
import {
  GetCupons,
  GetCuponsByData,
  GetDatasAtivacaoCupom,
} from "../../providers/CuponsProvider";
import { KeyboardDatePicker } from "@material-ui/pickers";
import Select from "react-select";

export default class CupomGrafico extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInicio: null,
      dataFim: null,
      modalEmitirRelatorio: false,
      relatorioDisponivel: false,
      loading: false,
      totalFaturado: 0,
      modalShow: true,
      date_show: [],
      cupons: [],
      cupom_selecionado: "",
      datas_ativacao: [],
      data: null,
    };
  }

  async componentDidMount() {
    const today = new Date();
    today.setHours(23);
    const thowWeeks = new Date(today);
    thowWeeks.setDate(today.getDate() - 15);
    this.setState(
      {
        dataInicio: thowWeeks,
        dataFim: today,
      },
      this.formatCupons,
    );
    this.setState({
      modalShow: false,
    });
    this.getCupons();
  }

  async formatData() {
    let d1 = this.state.dataInicio?._d;
    let d2 = this.state.dataFim?._d;

    let diff = moment(d2).diff(moment(d1));
    let date = [];
    let months = moment.duration(diff).asMonths();
    for (let i = 0; i <= months; i++) {
      let month = d1?.getMonth();
      let now = new Date(0, month + i, 1);
      date = [...date, now.toDateString().slice(4, 7)];
    }
    this.setState({
      date_show: date,
    });
  }
  async getCuponsByData() {
    const data_to_send = {
      data_inicio: this.state.dataInicio?.toISOString(),
      data_final: this.state.dataFim?.toISOString(),
    };
    let cupons = await GetCuponsByData(data_to_send);
    return cupons;
  }

  async getCupons() {
    const cupons = await GetCupons();
    cupons.map((a) => {
      this.setState({
        cupons: [...this.state.cupons, { label: a.codigo, value: a._id }],
      });
    });
  }

  async getDatasAtivacaoCupom(cupom) {
    if (!cupom?.value) return;
    const datas = await GetDatasAtivacaoCupom(cupom.value);
    this.setState({
      datas_ativacao: datas,
    });
  }

  async formatCupons() {
    this.formatData();
    const cupons = await this.getCuponsByData();
    const ativacoes = cupons.map((cupom) => cupom.num_ativacoes_geral);
    const names = cupons.map((cupom) => cupom.codigo);
    this.setState({ data: ativacoes, date_show: names });
  }

  render() {
    return (
      <div>
        <br></br>
        <h3>Gráficos</h3>
        <Row>
          <Col md={6}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <p style={{ marginBottom: 0, fontWeight: "bold" }}>Defina um período: </p>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-end",
                }}
              >
                <p style={{ marginRight: 30 }}>De</p>
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  margin="normal"
                  id="Data de início"
                  label="Data inicial"
                  value={this.state.dataInicio}
                  style={{ width: "60%" }}
                  maxDate={new Date()}
                  onChange={(d) => this.setState({ dataInicio: d })}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-end",
                }}
              >
                <p style={{ marginRight: 30 }}>Até</p>
                <KeyboardDatePicker
                  disableToolbar
                  disabled={!this.state.dataInicio}
                  variant="inline"
                  margin="normal"
                  id="date-picker-inline"
                  label="Data final"
                  minDate={this.state.dataInicio}
                  maxDate={new Date()}
                  value={this.state.dataFim}
                  style={{ width: "60%" }}
                  onChange={(d) => this.setState({ dataFim: d })}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  marginTop: 17,
                }}
              >
                <Button
                  style={{ height: 35 }}
                  onClick={async () => await this.formatCupons()}
                  disabled={this.state.data}
                >
                  Aplicar
                </Button>
                {this.state.dataInicio && this.state.dataFim ? (
                  <Button
                    variant="danger"
                    style={{ height: 35, marginLeft: 5 }}
                    onClick={() => {
                      this.setState({
                        dataInicio: new Date(),
                        dataFim: null,
                        data: null,
                      });
                    }}
                  >
                    Limpar
                  </Button>
                ) : null}
              </div>
            </div>
          </Col>
        </Row>
        <br></br>
        <Row>
          <Col md={{ offset: 6 }}>
            <Select
              placeholder="Selecione cupom especifico"
              value={this.state.cupom_selecionado}
              options={this.state.cupons}
              onChange={(opt) => {
                this.setState({ cupom_selecionado: opt });
                this.getDatasAtivacaoCupom(opt);
              }}
              isClearable
            />
          </Col>
        </Row>
        <br></br>
        <Row>
          <Col md={6}>
            <h4>Desempenho na data selecionada</h4>
            <Bar
              data={{
                labels: this.state.date_show,
                datasets: [
                  {
                    label: "Total de uso dos cupons",
                    fill: false,
                    borderColor: "#701B8C",
                    borderWidth: 1,
                    hoverBorderColor: "#ffffff",
                    data: this.state.data,
                  },
                ],
              }}
              options={{
                scales: {
                  yAxes: [
                    {
                      ticks: {
                        beginAtZero: true,
                        min: 0,
                        stepSize: 5,
                      },
                    },
                  ],
                },
              }}
            />
          </Col>
          <Col md={6}>
            <h4>Desempenho individual nos últimos 30 dias</h4>
            <Line
              data={{
                labels: this.state.datas_ativacao.map((d) => d._id),
                datasets: [
                  {
                    label: "Individual",
                    fill: false,
                    borderColor: "#701B8C",
                    borderWidth: 1,
                    hoverBorderColor: "#ffffff",
                    data: this.state.datas_ativacao.map((d) => d.count),
                  },
                ],
              }}
              options={{
                scales: {
                  yAxes: [
                    {
                      ticks: {
                        beginAtZero: true,
                        min: 0,
                        stepSize: 50,
                      },
                    },
                  ],
                },
              }}
            />
          </Col>
        </Row>

        <Modal
          show={this.state.modalShow}
          backdrop="static"
          keyboard={false}
          size="sm"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Body>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
              Carregando...
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
